export default __webpack_public_path__ + "static/media/Play_Icon.a9088c54.svg";